// // File: frontend/CostBreakdownTable.tsx
// // ===================================================
// // FINAL, COMPLETE, AND CORRECTED FILE

// import React, { useState, useCallback, useEffect, useMemo } from 'react';
// import {
//     Box,
//     Paper,
//     Typography,
//     TableContainer,
//     Table,
//     TableHead,
//     TableBody,
//     TableRow,
//     TableCell,
//     IconButton,
//     Tooltip,
//     CircularProgress,
//     FormControl,
//     Select,
//     MenuItem,
//     SelectChangeEvent,
//     Button,
// } from '@mui/material';
// import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
// import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
// import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
// import { useLazyQuery, gql, useApolloClient } from '@apollo/client';
// import { v4 as uuidv4 } from 'uuid';
// import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// // --- Error/Empty State Display Component ---
// const ErrorDisplay = ({ onRefresh }: { onRefresh: () => void; }) => (
//     <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', p: 3, height: '100%', minHeight: 250, }}>
//         <img src="/usmerror.svg" alt="Error" style={{ width: '130px', marginBottom: '16px' }} />
//         <Typography variant="h6" component="h2" sx={{ fontWeight: 600, mb: 1 }}>Unable to Display Data</Typography>
//         <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '300px', mb: 2 }}>We're having trouble loading activities right now. Please try again.</Typography>
//         <Button variant="text" onClick={onRefresh} sx={{ textTransform: 'none', color: '#0064FF', fontWeight: 500, fontFamily: 'Inter', lineHeight: '21px', fontSize: '14px' }}>Refresh Page</Button>
//     </Box>
// );

// // --- TYPE DEFINITIONS ---
// export enum KubernetesGroupBy { CLUSTER = 'CLUSTER', NAMESPACE = 'NAMESPACE', WORKLOAD = 'WORKLOAD' }
// export interface KubernetesCostBreakdownRow {
//     groupName: string;
//     level: KubernetesGroupBy;
//     provider: string;
//     dataSource: string;
//     dataSourceName?: string;
//     cpuCost: number;
//     memoryCost: number;
//     storageCost: number;
//     totalCost: number;
//     clusterName?: string;
//     totalCostChangePercentage?: number;
//     namespace?: string;
//     clusterOverheadCost?: number;
// }
// interface CostDataRow extends KubernetesCostBreakdownRow { id: string; statusColor: string; providerIcon?: string; change?: string; changeType?: 'increase' | 'decrease'; children?: CostDataRow[]; }
// interface ExpandableRowProps { row: CostDataRow; level: number; expandedIds: Set<string>; loadingChildren: Set<string>; onToggle: (rowId: string) => void; isStriped?: boolean; isFirstChild?: boolean; }
// interface CostBreakdownTableProps {
//     tenantId: string;
//     dateRange: { start: string; end: string };
//     filters: { dataSourceIds?: string[] | null; clusters?: string[] | null; namespaces?: string[] | null; labels?: { key: string; value: string; }[] | null; };
//     colorMap: { [key: string]: string }; 
// }

// // --- GRAPHQL QUERY ---
// const GET_KUBERNETES_BREAKDOWN_DATA = gql`
//     query GetKubernetesBreakdownData($tenantId: ID!, $dateRange: TimeRangeInput!, $filters: KubernetesAnalysisFiltersInput, $groupBy: KubernetesGroupBy!) {
//         getKubernetesBreakdownData(input: { tenantId: $tenantId, dateRange: $dateRange, filters: $filters, groupBy: $groupBy }) {
//             groupName, level, provider, dataSource, dataSourceName, cpuCost, memoryCost, storageCost, totalCost, totalCostChangePercentage, clusterOverheadCost
//         }
//     }
// `;

// // --- HELPER FUNCTIONS ---
// const formatCurrency = (value: number | null | undefined) => (value === null || value === undefined) ? '$0.00' : `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
// const getProviderIcon = (provider: string) => { switch (provider.toLowerCase()) { case 'gcp': return 'https://img.icons8.com/color/48/google-cloud.png'; case 'aws': return 'https://img.icons8.com/color/48/amazon-web-services.png'; case 'azure': return 'https://img.icons8.com/color/48/azure.png'; default: return ''; } };

// // --- RECURSIVE ROW COMPONENT ---
// const ExpandableRow: React.FC<ExpandableRowProps> = ({ row, level, expandedIds, loadingChildren, onToggle, isStriped, isFirstChild = false }) => {
//     const isExpanded = expandedIds.has(row.id);
//     const isExpandable = row.level !== KubernetesGroupBy.WORKLOAD;
//     const isLoading = loadingChildren.has(row.id);
//     const hasOverhead = row.level === KubernetesGroupBy.CLUSTER && row.clusterOverheadCost != null && row.clusterOverheadCost > 0;
//     const overheadTooltipText = `Includes ${formatCurrency(row.clusterOverheadCost)} in cluster overhead. These are shared costs, such as GKE Autopilot fees`;
//     const changeType = row.totalCostChangePercentage != null && row.totalCostChangePercentage >= 0 ? 'increase' : 'decrease';
//     const changeValue = row.totalCostChangePercentage != null ? `${row.totalCostChangePercentage >= 0 ? '+' : ''}${row.totalCostChangePercentage.toFixed(2)}%` : null;
//     const isNamespaceRow = level === 1;
//     const showWorkloadDivider = level === 2 && !isFirstChild;
//     const dividerMarginLeft = 24 + (level * 24);
//     const fullDividerStyle = { borderTop: isNamespaceRow ? '1px solid #EAECF0' : 'none' };
//     let fontWeight;
//     switch (level) { case 0: fontWeight = 600; break; case 1: fontWeight = 500; break; case 2: fontWeight = 400; break; default: fontWeight = 400; }
//     const textStyle = { fontFamily: 'Inter, sans-serif', fontSize: '14px', fontWeight, color: '#101828', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', ...(level > 0 && { ml: 0 }), };

//     return (
//         <React.Fragment>
//             {showWorkloadDivider && (<TableRow><TableCell colSpan={7} sx={{ padding: 0, border: 'none' }}><Box sx={{ borderTop: '1px solid #EAECF0', marginLeft: `${dividerMarginLeft}px` }} /></TableCell></TableRow>)}
//             <TableRow sx={{ backgroundColor: (() => { if (isExpanded) { if (level === 0) return '#E5EFFF'; if (level === 1) return '#F2F4F7'; } return level === 0 && isStriped ? '#F9FAFB' : '#FFFFFF'; })(), '& .MuiTableCell-root': { borderBottom: 'none' }, '&:hover': { backgroundColor: isExpanded ? undefined : '#F5FAFF' }, }}>
//                 <TableCell component="th" scope="row" sx={{ ...fullDividerStyle, py: '16px', pl: 3, pr: '24px' }}><Box sx={{ display: 'flex', alignItems: 'center', pl: `${level * 24}px` }}><Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>{isExpandable && (<IconButton size="small" onClick={() => onToggle(row.id)} disabled={isLoading}>{isLoading ? <CircularProgress size={20} /> : isExpanded ? <RemoveCircleOutlineIcon sx={{ color: '#98A2B3', fontSize: '1rem' }} /> : <AddCircleOutlineIcon sx={{ color: '#98A2B3', fontSize: '1rem' }} />}</IconButton>)}</Box>{level === 0 && <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: row.statusColor, flexShrink: 0, mr: 1.5 }} />}<Tooltip title={row.groupName} placement="top-start"><Typography sx={textStyle}>{row.groupName}</Typography></Tooltip></Box></TableCell>
//                 {level === 0 ? (<><TableCell sx={{ ...fullDividerStyle, py: '16px', px: '24px' }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>{row.provider && <img src={getProviderIcon(row.provider)} alt={row.provider || ''} style={{ width: '20px', height: '20px' }} />}<Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', color: '#475467' }}>{row.provider}</Typography></Box></TableCell><TableCell sx={{ ...fullDividerStyle, py: '16px', px: '24px' }}><Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', color: '#475467', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.dataSourceName || row.dataSource}</Typography></TableCell></>) : (<><TableCell sx={fullDividerStyle} /><TableCell sx={fullDividerStyle} /></>)}
//                 <TableCell align="left" sx={{ ...fullDividerStyle, fontFamily: 'Inter, sans-serif', fontSize: '14px', color: '#475467', py: '16px', px: '24px' }}>{formatCurrency(row.cpuCost)}</TableCell>
//                 <TableCell align="left" sx={{ ...fullDividerStyle, fontFamily: 'Inter, sans-serif', fontSize: '14px', color: '#475467', py: '16px', px: '24px' }}>{formatCurrency(row.memoryCost)}</TableCell>
//                 <TableCell align="left" sx={{ ...fullDividerStyle, fontFamily: 'Inter, sans-serif', fontSize: '14px', color: '#475467', py: '16px', px: '24px' }}>{formatCurrency(row.storageCost)}</TableCell>
//                 <TableCell align="left" sx={{ ...fullDividerStyle, py: '16px', px: '7px' }}><Tooltip title={hasOverhead ? overheadTooltipText : ''} placement="top"><Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 0.5, cursor: hasOverhead ? 'help' : 'default' }}>{changeValue && (<>{changeType === 'increase' ? <ArrowUpwardIcon sx={{ width: '16px', height: '16px', color: '#027A48' }} /> : <ArrowDownwardIcon sx={{ width: '16px', height: '16px', color: '#B42318' }} />}<Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', color: changeType === 'increase' ? '#027A48' : '#B42318', mr: 1 }}>{changeValue}</Typography></>)}<Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', fontWeight: 400, color: '#101828' }}>{formatCurrency(row.totalCost)}</Typography></Box></Tooltip></TableCell>
//             </TableRow>
//             {isExpanded && row.children && row.children.map((childRow, index) => (<ExpandableRow key={childRow.id} row={childRow} level={level + 1} expandedIds={expandedIds} loadingChildren={loadingChildren} onToggle={onToggle} isFirstChild={index === 0} />))}
//         </React.Fragment>
//     );
// };

// // --- MAIN TABLE COMPONENT ---
// const CostBreakdownTable: React.FC<CostBreakdownTableProps> = ({ tenantId, dateRange, filters, colorMap }) => {
//     // --- START OF THE FIX ---
//     // 1. New state for the raw, unprocessed data from the API
//     const [rawInitialData, setRawInitialData] = useState<KubernetesCostBreakdownRow[] | null>(null);
//     const [tableData, setTableData] = useState<CostDataRow[]>([]);
//     // --- END OF THE FIX: STEP 1 ---

//     const [expandedIds, setExpandedIds] = useState<Set<string>>(new Set());
//     const [loadingChildren, setLoadingChildren] = useState<Set<string>>(new Set());
//     const [page, setPage] = useState(1);
//     const [rowsPerPage, setRowsPerPage] = useState(5);
//     const client = useApolloClient();

//     const [getInitialData, { loading: initialLoading, error: initialError }] = useLazyQuery<{ getKubernetesBreakdownData: KubernetesCostBreakdownRow[] }>(
//         GET_KUBERNETES_BREAKDOWN_DATA,
//         {
//             fetchPolicy: 'network-only',
//             // --- START OF THE FIX ---
//             // 2. onCompleted ONLY saves the raw data. No processing happens here.
//             onCompleted: (data) => {
//                 setRawInitialData(data?.getKubernetesBreakdownData || []);
//             },
//             onError: (err) => {
//                 console.error("Error fetching initial breakdown data:", err);
//                 setRawInitialData([]);
//             },
//             // --- END OF THE FIX: STEP 2 ---
//         }
//     );

//     // --- START OF THE FIX ---
//     // 3. A new useEffect to process data, which solves the race condition.
//     useEffect(() => {
//         // This logic only runs when we have BOTH the data AND a ready colorMap.
//         if (rawInitialData && Object.keys(colorMap).length > 0) {
//             const processedData: CostDataRow[] = rawInitialData.map(row => ({
//                 ...row,
//                 id: uuidv4(),
//                 statusColor: colorMap[row.groupName] || '#CCCCCC', // Guaranteed to have the right colorMap
//                 providerIcon: getProviderIcon(row.provider),
//                 // children: [],
//             }));
//             setTableData(processedData);
//         }
//     }, [rawInitialData, colorMap]); // This dependency array is the key to the fix.
//     // --- END OF THE FIX: STEP 3 ---
    
//     const fetchData = useCallback(() => {
//         setRawInitialData(null); // Reset state on new fetch
//         setTableData([]);
//         getInitialData({ variables: { tenantId, dateRange, filters, groupBy: KubernetesGroupBy.CLUSTER } });
//         setExpandedIds(new Set());
//         setLoadingChildren(new Set());
//     }, [tenantId, dateRange, filters, getInitialData]);

//     useEffect(() => { fetchData(); }, [fetchData]);
//     useEffect(() => { setPage(1); }, [filters, dateRange]);

//     const updateNodeChildren = useCallback((nodes: CostDataRow[], targetId: string, newChildren: CostDataRow[]): CostDataRow[] => {
//         return nodes.map(node => {
//             if (node.id === targetId) return { ...node, children: newChildren };
//             if (node.children?.length) return { ...node, children: updateNodeChildren(node.children, targetId, newChildren) };
//             return node;
//         });
//     }, []);

//     const findRowById = (nodes: CostDataRow[], id: string): CostDataRow | undefined => {
//         for (const node of nodes) {
//             if (node.id === id) return node;
//             if (node.children) {
//                 const found = findRowById(node.children, id);
//                 if (found) return found;
//             }
//         }
//         return undefined;
//     };
    
//     const fetchChildrenForParent = useCallback(async (row: CostDataRow) => {
//         if (loadingChildren.has(row.id)) return;
//         setLoadingChildren(prev => new Set(prev).add(row.id));
//         let nextGroupBy: KubernetesGroupBy;
//         const newFilters = { ...filters };
//         if (row.level === KubernetesGroupBy.CLUSTER) { nextGroupBy = KubernetesGroupBy.NAMESPACE; newFilters.clusters = [row.groupName]; newFilters.namespaces = null;
//         } else if (row.level === KubernetesGroupBy.NAMESPACE) { nextGroupBy = KubernetesGroupBy.WORKLOAD; newFilters.clusters = row.clusterName ? [row.clusterName] : null; newFilters.namespaces = [row.groupName];
//         } else { setLoadingChildren(prev => { const newSet = new Set(prev); newSet.delete(row.id); return newSet; }); return; }
//         try {
//             const result = await client.query<{ getKubernetesBreakdownData: KubernetesCostBreakdownRow[] }>({ query: GET_KUBERNETES_BREAKDOWN_DATA, variables: { tenantId, dateRange, filters: newFilters, groupBy: nextGroupBy }, fetchPolicy: 'network-only', });
//             const children = result.data.getKubernetesBreakdownData || [];
//             const mappedChildren: CostDataRow[] = children.map(child => ({ ...child, id: uuidv4(), statusColor: '', providerIcon: getProviderIcon(child.provider), clusterName: nextGroupBy === KubernetesGroupBy.NAMESPACE ? row.groupName : row.clusterName, namespace: nextGroupBy === KubernetesGroupBy.WORKLOAD ? row.groupName : row.namespace, }));
//             setTableData(currentData => updateNodeChildren(currentData, row.id, mappedChildren));
//         } catch (err) { console.error(`Error fetching child data for row: ${row.id}`, err);
//         } finally { setLoadingChildren(prev => { const newSet = new Set(prev); newSet.delete(row.id); return newSet; }); }
//     }, [client, dateRange, filters, loadingChildren, tenantId, updateNodeChildren]);

//     useEffect(() => {
//         expandedIds.forEach(id => {
//             const row = findRowById(tableData, id);
//             if (row && row.children === undefined) {
//                 fetchChildrenForParent(row);
//             }
//         });
//     }, [expandedIds, tableData, fetchChildrenForParent]);

//     const handleToggle = useCallback((rowId: string) => {
//         setExpandedIds(prev => { const newSet = new Set(prev); if (newSet.has(rowId)) { newSet.delete(rowId); } else { newSet.add(rowId); } return newSet; });
//     }, []);

//     const pageCount = Math.ceil(tableData.length / rowsPerPage);
//     const paginatedData = useMemo(() => { const startIndex = (page - 1) * rowsPerPage; return tableData.slice(startIndex, startIndex + rowsPerPage); }, [tableData, page, rowsPerPage]);
//     const showingFrom = tableData.length > 0 ? (page - 1) * rowsPerPage + 1 : 0;
//     const showingTo = Math.min(page * rowsPerPage, tableData.length);
//     const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => { setRowsPerPage(event.target.value as number); setPage(1); };
//     const displayLoading = initialLoading || (rawInitialData === null && !initialError);
//     const showEmptyOrErrorState = !displayLoading && (!!initialError || tableData.length === 0);

//     return (
//         <Box sx={{ mt: 2, pt: 2, pb: 2, px: 0, width: '100%', backgroundColor: '#FFFFFF', borderRadius: '16px' }}>
//             <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '18px', color: '#101828', mb: 2, px: 3 }}>Cost Breakdown</Typography>
//             {displayLoading ? (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}><CircularProgress /></Box>
//             ) : showEmptyOrErrorState ? (<ErrorDisplay onRefresh={fetchData} />
//             ) : (
//                 <>
//                     <TableContainer component={Paper} elevation={0}>
//                         <Table sx={{ minWidth: 650, borderCollapse: 'collapse', tableLayout: 'fixed', width: '100%' }} aria-label="cost breakdown table">
//                             <TableHead><TableRow sx={{ '& .MuiTableCell-root': { borderBottom: 'none', py: '12px', px: '24px', color: '#475467', fontWeight: 400, fontSize: '12px' } }}><TableCell sx={{ pl: 3, width: '30%' }}>Cluster/ Namespace/ Workload</TableCell><TableCell sx={{ width: '10%' }}>Provider</TableCell><TableCell sx={{ width: '15%' }}>Data Source</TableCell><TableCell align="left" sx={{ width: '10%' }}>CPU Cost</TableCell><TableCell align="left" sx={{ width: '10%' }}>Memory Cost</TableCell><TableCell align="left" sx={{ width: '10%' }}>Storage Cost</TableCell><TableCell align="left" sx={{ width: '15%' }}>Total Cost</TableCell></TableRow></TableHead>
//                             <TableBody>{paginatedData.map((row, index) => (<ExpandableRow key={row.id} row={row} level={0} expandedIds={expandedIds} loadingChildren={loadingChildren} onToggle={handleToggle} isStriped={((page - 1) * rowsPerPage + index) % 2 === 0} />))}</TableBody>
//                         </Table>
//                     </TableContainer>
//                     <Box sx={{ flexShrink: 0, mt: 1, mb: 0, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, minHeight: '3.5rem', padding: '0 1.5rem', backgroundColor: '#FFFFFF', }}>
//                         <Typography sx={{ fontFamily: 'Inter', fontSize: '0.875rem', color: 'text.secondary' }}>Rows per page:</Typography>
//                         <FormControl size="small"><Select value={rowsPerPage} onChange={handleRowsPerPageChange} sx={{ fontFamily: 'Inter', fontSize: '0.875rem', color: 'text.secondary', '.MuiOutlinedInput-notchedOutline': { border: 'none' }, '.MuiSelect-select': { padding: '4px 8px' }, }}><MenuItem value={5}>5</MenuItem><MenuItem value={10}>10</MenuItem><MenuItem value={20}>20</MenuItem></Select></FormControl>
//                         <Typography sx={{ fontFamily: 'Inter', fontSize: '0.875rem', color: 'text.secondary', fontWeight: 500 }}>{showingFrom} - {showingTo} of {tableData.length}</Typography>
//                         <IconButton onClick={() => setPage(page - 1)} disabled={page === 1} aria-label="previous page"><ArrowBackIosNewIcon sx={{ fontSize: '1rem' }} /></IconButton>
//                         <IconButton onClick={() => setPage(page + 1)} disabled={page === pageCount} aria-label="next page"><ArrowForwardIosIcon sx={{ fontSize: '1rem' }} /></IconButton>
//                     </Box>
//                 </>
//             )}
//         </Box>
//     );
// };

// export default CostBreakdownTable;

// File: frontend/CostBreakdownTable.tsx
// ===================================================
// FINAL, COMPLETE, AND CORRECTED FILE

import React, { useState, useCallback, useEffect, useMemo } from 'react';
import {
    Box,
    Paper,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    IconButton,
    Tooltip,
    CircularProgress,
    FormControl,
    Select,
    MenuItem,
    SelectChangeEvent,
    Button,
} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { useLazyQuery, gql, useApolloClient } from '@apollo/client';
import { v4 as uuidv4 } from 'uuid';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// --- Error/Empty State Display Component ---
const ErrorDisplay = ({ onRefresh }: { onRefresh: () => void; }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', p: 3, height: '100%', minHeight: 250, }}>
        <img src="/usmerror.svg" alt="Error" style={{ width: '130px', marginBottom: '16px' }} />
        <Typography variant="h6" component="h2" sx={{ fontWeight: 600, mb: 1 }}>Unable to Display Data</Typography>
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '300px', mb: 2 }}>We're having trouble loading activities right now. Please try again.</Typography>
        <Button variant="text" onClick={onRefresh} sx={{ textTransform: 'none', color: '#0064FF', fontWeight: 500, fontFamily: 'Inter', lineHeight: '21px', fontSize: '14px' }}>Refresh Page</Button>
    </Box>
);

// --- TYPE DEFINITIONS ---
export enum KubernetesGroupBy { CLUSTER = 'CLUSTER', NAMESPACE = 'NAMESPACE', WORKLOAD = 'WORKLOAD' }
export interface KubernetesCostBreakdownRow {
    groupName: string;
    level: KubernetesGroupBy;
    provider: string;
    dataSource: string;
    dataSourceName?: string;
    cpuCost: number;
    memoryCost: number;
    storageCost: number;
    totalCost: number;
    clusterName?: string;
    totalCostChangePercentage?: number;
    namespace?: string;
    clusterOverheadCost?: number;
}
interface CostDataRow extends KubernetesCostBreakdownRow { id: string; statusColor: string; providerIcon?: string; change?: string; changeType?: 'increase' | 'decrease'; children?: CostDataRow[]; }
interface ExpandableRowProps { row: CostDataRow; level: number; expandedIds: Set<string>; loadingChildren: Set<string>; onToggle: (rowId: string) => void; isStriped?: boolean; isFirstChild?: boolean; }
interface CostBreakdownTableProps {
    tenantId: string;
    dateRange: { start: string; end: string };
    filters: { dataSourceIds?: string[] | null; clusters?: string[] | null; namespaces?: string[] | null; labels?: { key: string; value: string; }[] | null; };
    colorMap: { [key: string]: string }; 
}

// --- GRAPHQL QUERY ---
const GET_KUBERNETES_BREAKDOWN_DATA = gql`
    query GetKubernetesBreakdownData($tenantId: ID!, $dateRange: TimeRangeInput!, $filters: KubernetesAnalysisFiltersInput, $groupBy: KubernetesGroupBy!) {
        getKubernetesBreakdownData(input: { tenantId: $tenantId, dateRange: $dateRange, filters: $filters, groupBy: $groupBy }) {
            groupName, level, provider, dataSource, dataSourceName, cpuCost, memoryCost, storageCost, totalCost, totalCostChangePercentage, clusterOverheadCost
        }
    }
`;

// --- HELPER FUNCTIONS ---
const formatCurrency = (value: number | null | undefined) => (value === null || value === undefined) ? '$0.00' : `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const getProviderIcon = (provider: string) => { switch (provider.toLowerCase()) { case 'gcp': return 'https://img.icons8.com/color/48/google-cloud.png'; case 'aws': return 'https://img.icons8.com/color/48/amazon-web-services.png'; case 'azure': return 'https://img.icons8.com/color/48/azure.png'; default: return ''; } };

// --- RECURSIVE ROW COMPONENT ---
const ExpandableRow: React.FC<ExpandableRowProps> = ({ row, level, expandedIds, loadingChildren, onToggle, isStriped, isFirstChild = false }) => {
    const isExpanded = expandedIds.has(row.id);
    const isExpandable = row.level !== KubernetesGroupBy.WORKLOAD;
    const isLoading = loadingChildren.has(row.id);
    const hasOverhead = row.level === KubernetesGroupBy.CLUSTER && row.clusterOverheadCost != null && row.clusterOverheadCost > 0;
    const overheadTooltipText = `Includes ${formatCurrency(row.clusterOverheadCost)} in cluster overhead. These are shared costs, such as GKE Autopilot fees`;
    const changeType = row.totalCostChangePercentage != null && row.totalCostChangePercentage >= 0 ? 'increase' : 'decrease';
    const changeValue = row.totalCostChangePercentage != null ? `${row.totalCostChangePercentage >= 0 ? '+' : ''}${row.totalCostChangePercentage.toFixed(2)}%` : null;
    const isNamespaceRow = level === 1;
    const showWorkloadDivider = level === 2 && !isFirstChild;
    const dividerMarginLeft = 24 + (level * 24);
    const fullDividerStyle = { borderTop: isNamespaceRow ? '1px solid #EAECF0' : 'none' };
    let fontWeight;
    switch (level) { case 0: fontWeight = 600; break; case 1: fontWeight = 500; break; case 2: fontWeight = 400; break; default: fontWeight = 400; }
    const textStyle = { fontFamily: 'Inter, sans-serif', fontSize: '14px', fontWeight, color: '#101828', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', ...(level > 0 && { ml: 0 }), };

    return (
        <React.Fragment>
            {showWorkloadDivider && (<TableRow><TableCell colSpan={7} sx={{ padding: 0, border: 'none' }}><Box sx={{ borderTop: '1px solid #EAECF0', marginLeft: `${dividerMarginLeft}px` }} /></TableCell></TableRow>)}
            <TableRow sx={{ backgroundColor: (() => { if (isExpanded) { if (level === 0) return '#E5EFFF'; if (level === 1) return '#F2F4F7'; } return level === 0 && isStriped ? '#F9FAFB' : '#FFFFFF'; })(), '& .MuiTableCell-root': { borderBottom: 'none' }, '&:hover': { backgroundColor: isExpanded ? undefined : '#F5FAFF' }, }}>
                <TableCell component="th" scope="row" sx={{ ...fullDividerStyle, py: '16px', pl: 3, pr: '24px' }}><Box sx={{ display: 'flex', alignItems: 'center', pl: `${level * 24}px` }}><Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>{isExpandable && (<IconButton size="small" onClick={() => onToggle(row.id)} disabled={isLoading}>{isLoading ? <CircularProgress size={20} /> : isExpanded ? <RemoveCircleOutlineIcon sx={{ color: '#98A2B3', fontSize: '1rem' }} /> : <AddCircleOutlineIcon sx={{ color: '#98A2B3', fontSize: '1rem' }} />}</IconButton>)}</Box>{level === 0 && <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: row.statusColor, flexShrink: 0, mr: 1.5 }} />}<Tooltip title={row.groupName} placement="top-start"><Typography sx={textStyle}>{row.groupName}</Typography></Tooltip></Box></TableCell>
                {level === 0 ? (<><TableCell sx={{ ...fullDividerStyle, py: '16px', px: '24px' }}><Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>{row.provider && <img src={getProviderIcon(row.provider)} alt={row.provider || ''} style={{ width: '20px', height: '20px' }} />}<Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', color: '#475467' }}>{row.provider}</Typography></Box></TableCell><TableCell sx={{ ...fullDividerStyle, py: '16px', px: '24px' }}><Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', color: '#475467', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{row.dataSourceName || row.dataSource}</Typography></TableCell></>) : (<><TableCell sx={fullDividerStyle} /><TableCell sx={fullDividerStyle} /></>)}
                <TableCell align="left" sx={{ ...fullDividerStyle, fontFamily: 'Inter, sans-serif', fontSize: '14px', color: '#475467', py: '16px', px: '24px' }}>{formatCurrency(row.cpuCost)}</TableCell>
                <TableCell align="left" sx={{ ...fullDividerStyle, fontFamily: 'Inter, sans-serif', fontSize: '14px', color: '#475467', py: '16px', px: '24px' }}>{formatCurrency(row.memoryCost)}</TableCell>
                <TableCell align="left" sx={{ ...fullDividerStyle, fontFamily: 'Inter, sans-serif', fontSize: '14px', color: '#475467', py: '16px', px: '24px' }}>{formatCurrency(row.storageCost)}</TableCell>
                <TableCell align="left" sx={{ ...fullDividerStyle, py: '16px', px: '7px' }}><Tooltip title={hasOverhead ? overheadTooltipText : ''} placement="top"><Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 0.5, cursor: hasOverhead ? 'help' : 'default' }}>{changeValue && (<>{changeType === 'increase' ? <ArrowUpwardIcon sx={{ width: '16px', height: '16px', color: '#027A48' }} /> : <ArrowDownwardIcon sx={{ width: '16px', height: '16px', color: '#B42318' }} />}<Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', color: changeType === 'increase' ? '#027A48' : '#B42318', mr: 1 }}>{changeValue}</Typography></>)}<Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', fontWeight: 400, color: '#101828' }}>{formatCurrency(row.totalCost)}</Typography></Box></Tooltip></TableCell>
            </TableRow>
            {isExpanded && row.children && row.children.map((childRow, index) => (<ExpandableRow key={childRow.id} row={childRow} level={level + 1} expandedIds={expandedIds} loadingChildren={loadingChildren} onToggle={onToggle} isFirstChild={index === 0} />))}
        </React.Fragment>
    );
};

// --- MAIN TABLE COMPONENT ---
const CostBreakdownTable: React.FC<CostBreakdownTableProps> = ({ tenantId, dateRange, filters, colorMap }) => {
    const [rawInitialData, setRawInitialData] = useState<KubernetesCostBreakdownRow[] | null>(null);
    const [tableData, setTableData] = useState<CostDataRow[]>([]);
    const [expandedIds, setExpandedIds] = useState<Set<string>>(new Set());
    const [loadingChildren, setLoadingChildren] = useState<Set<string>>(new Set());
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const client = useApolloClient();

    const [getInitialData, { loading: initialLoading, error: initialError }] = useLazyQuery<{ getKubernetesBreakdownData: KubernetesCostBreakdownRow[] }>(
        GET_KUBERNETES_BREAKDOWN_DATA,
        {
            fetchPolicy: 'network-only',
            onCompleted: (data) => {
                setRawInitialData(data?.getKubernetesBreakdownData || []);
            },
            onError: (err) => {
                console.error("Error fetching initial breakdown data:", err);
                setRawInitialData([]);
            },
        }
    );

    useEffect(() => {
        if (rawInitialData && Object.keys(colorMap).length > 0) {
            const processedData: CostDataRow[] = rawInitialData.map(row => ({
                ...row,
                id: uuidv4(),
                statusColor: colorMap[row.groupName] || '#CCCCCC',
                providerIcon: getProviderIcon(row.provider),
            }));
            setTableData(processedData);
        }
    }, [rawInitialData, colorMap]); 
    
    const fetchData = useCallback(() => {
        setRawInitialData(null); 
        setTableData([]);
        getInitialData({ variables: { tenantId, dateRange, filters, groupBy: KubernetesGroupBy.CLUSTER } });
        setExpandedIds(new Set());
        setLoadingChildren(new Set());
    }, [tenantId, dateRange, filters, getInitialData]);

    useEffect(() => { fetchData(); }, [fetchData]);
    useEffect(() => { setPage(1); }, [filters, dateRange]);

    const updateNodeChildren = useCallback((nodes: CostDataRow[], targetId: string, newChildren: CostDataRow[]): CostDataRow[] => {
        return nodes.map(node => {
            if (node.id === targetId) return { ...node, children: newChildren };
            if (node.children?.length) return { ...node, children: updateNodeChildren(node.children, targetId, newChildren) };
            return node;
        });
    }, []);

    const findRowById = (nodes: CostDataRow[], id: string): CostDataRow | undefined => {
        for (const node of nodes) {
            if (node.id === id) return node;
            if (node.children) {
                const found = findRowById(node.children, id);
                if (found) return found;
            }
        }
        return undefined;
    };
    
    const fetchChildrenForParent = useCallback(async (row: CostDataRow) => {
        if (loadingChildren.has(row.id)) return;
        setLoadingChildren(prev => new Set(prev).add(row.id));
        let nextGroupBy: KubernetesGroupBy;
        const newFilters = { ...filters };
        if (row.level === KubernetesGroupBy.CLUSTER) { nextGroupBy = KubernetesGroupBy.NAMESPACE; newFilters.clusters = [row.groupName]; newFilters.namespaces = null;
        } else if (row.level === KubernetesGroupBy.NAMESPACE) { nextGroupBy = KubernetesGroupBy.WORKLOAD; newFilters.clusters = row.clusterName ? [row.clusterName] : null; newFilters.namespaces = [row.groupName];
        } else { setLoadingChildren(prev => { const newSet = new Set(prev); newSet.delete(row.id); return newSet; }); return; }
        try {
            const result = await client.query<{ getKubernetesBreakdownData: KubernetesCostBreakdownRow[] }>({ query: GET_KUBERNETES_BREAKDOWN_DATA, variables: { tenantId, dateRange, filters: newFilters, groupBy: nextGroupBy }, fetchPolicy: 'network-only', });
            const children = result.data.getKubernetesBreakdownData || [];
            const mappedChildren: CostDataRow[] = children.map(child => ({ ...child, id: uuidv4(), statusColor: '', providerIcon: getProviderIcon(child.provider), clusterName: nextGroupBy === KubernetesGroupBy.NAMESPACE ? row.groupName : row.clusterName, namespace: nextGroupBy === KubernetesGroupBy.WORKLOAD ? row.groupName : row.namespace, }));
            setTableData(currentData => updateNodeChildren(currentData, row.id, mappedChildren));
        } catch (err) { console.error(`Error fetching child data for row: ${row.id}`, err);
        } finally { setLoadingChildren(prev => { const newSet = new Set(prev); newSet.delete(row.id); return newSet; }); }
    }, [client, dateRange, filters, loadingChildren, tenantId, updateNodeChildren]);

    useEffect(() => {
        expandedIds.forEach(id => {
            const row = findRowById(tableData, id);
            if (row && row.children === undefined) {
                fetchChildrenForParent(row);
            }
        });
    }, [expandedIds, tableData, fetchChildrenForParent]);

    const handleToggle = useCallback((rowId: string) => {
        setExpandedIds(prev => { const newSet = new Set(prev); if (newSet.has(rowId)) { newSet.delete(rowId); } else { newSet.add(rowId); } return newSet; });
    }, []);

    const pageCount = Math.ceil(tableData.length / rowsPerPage);
    const paginatedData = useMemo(() => { const startIndex = (page - 1) * rowsPerPage; return tableData.slice(startIndex, startIndex + rowsPerPage); }, [tableData, page, rowsPerPage]);
    const showingFrom = tableData.length > 0 ? (page - 1) * rowsPerPage + 1 : 0;
    const showingTo = Math.min(page * rowsPerPage, tableData.length);
    const handleRowsPerPageChange = (event: SelectChangeEvent<number>) => { setRowsPerPage(event.target.value as number); setPage(1); };
    
    const displayLoading = initialLoading || (rawInitialData === null && !initialError);
    // --- START OF THE FIX ---
    // This condition now correctly checks the source data (`rawInitialData`) instead of the processed data (`tableData`).
    const showEmptyOrErrorState = !displayLoading && (!!initialError || rawInitialData?.length === 0);
    // --- END OF THE FIX ---

    return (
        <Box sx={{ mt: 2, pt: 2, pb: 2, px: 0, width: '100%', backgroundColor: '#FFFFFF', borderRadius: '16px' }}>
            <Typography sx={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '18px', color: '#101828', mb: 2, px: 3 }}>Cost Breakdown</Typography>
            {displayLoading ? (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}><CircularProgress /></Box>
            ) : showEmptyOrErrorState ? (<ErrorDisplay onRefresh={fetchData} />
            ) : (
                <>
                    <TableContainer component={Paper} elevation={0}>
                        <Table sx={{ minWidth: 650, borderCollapse: 'collapse', tableLayout: 'fixed', width: '100%' }} aria-label="cost breakdown table">
                            <TableHead><TableRow sx={{ '& .MuiTableCell-root': { borderBottom: 'none', py: '12px', px: '24px', color: '#475467', fontWeight: 400, fontSize: '12px' } }}><TableCell sx={{ pl: 3, width: '30%' }}>Cluster/ Namespace/ Workload</TableCell><TableCell sx={{ width: '10%' }}>Provider</TableCell><TableCell sx={{ width: '15%' }}>Data Source</TableCell><TableCell align="left" sx={{ width: '10%' }}>CPU Cost</TableCell><TableCell align="left" sx={{ width: '10%' }}>Memory Cost</TableCell><TableCell align="left" sx={{ width: '10%' }}>Storage Cost</TableCell><TableCell align="left" sx={{ width: '15%' }}>Total Cost</TableCell></TableRow></TableHead>
                            <TableBody>{paginatedData.map((row, index) => (<ExpandableRow key={row.id} row={row} level={0} expandedIds={expandedIds} loadingChildren={loadingChildren} onToggle={handleToggle} isStriped={((page - 1) * rowsPerPage + index) % 2 === 0} />))}</TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ flexShrink: 0, mt: 1, mb: 0, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2, minHeight: '3.5rem', padding: '0 1.5rem', backgroundColor: '#FFFFFF', }}>
                        <Typography sx={{ fontFamily: 'Inter', fontSize: '0.875rem', color: 'text.secondary' }}>Rows per page:</Typography>
                        <FormControl size="small"><Select value={rowsPerPage} onChange={handleRowsPerPageChange} sx={{ fontFamily: 'Inter', fontSize: '0.875rem', color: 'text.secondary', '.MuiOutlinedInput-notchedOutline': { border: 'none' }, '.MuiSelect-select': { padding: '4px 8px' }, }}><MenuItem value={5}>5</MenuItem><MenuItem value={10}>10</MenuItem><MenuItem value={20}>20</MenuItem></Select></FormControl>
                        <Typography sx={{ fontFamily: 'Inter', fontSize: '0.875rem', color: 'text.secondary', fontWeight: 500 }}>{showingFrom} - {showingTo} of {tableData.length}</Typography>
                        <IconButton onClick={() => setPage(page - 1)} disabled={page === 1} aria-label="previous page"><ArrowBackIosNewIcon sx={{ fontSize: '1rem' }} /></IconButton>
                        <IconButton onClick={() => setPage(page + 1)} disabled={page === pageCount} aria-label="next page"><ArrowForwardIosIcon sx={{ fontSize: '1rem' }} /></IconButton>
                    </Box>
                </>
            )}
        </Box>
    );
};

export default CostBreakdownTable;